// 항상 윈도우 가장 아래로 스크롤
export function scrollToWindowBottommost() {
  if (typeof window === 'undefined') {
    return;
  }
  window.scrollTo(0, document.body.scrollHeight - window.innerHeight);
}
